// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/crosswind-takeoff-technique.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/crosswind-takeoff-technique/crosswind-takeoff-technique.js';

mount([g0]);
